import { Controller } from "@hotwired/stimulus"

// Dropdown controller for user menu
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundClose = this.close.bind(this)
  }

  disconnect() {
    this.removeClickListener()
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    // Close dropdown when clicking outside
    setTimeout(() => {
      document.addEventListener("click", this.boundClose)
    }, 10)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.removeClickListener()
  }

  removeClickListener() {
    document.removeEventListener("click", this.boundClose)
  }
}
